import { tokenPrefix } from '../../theme/tokenPrefix'
import { tokenVar } from '../../theme/tokenVar'
import type { ColorScheme } from '../../types'

/**
 * CSS variables an app can set high in the DOM (e.g. on <body>) to steer the
 * text-selection highlight for every DarkProvider scope that doesn't pass an
 * explicit colorScheme — and, via the system's global ::selection rule, for
 * content portaled outside any scope. Point them at the selection tokens,
 * e.g. tokenVar('colors.light.interactive.text-selection-bg').
 */
export const SELECTION_BG_VAR = '--hw-dark-selection-bg'
export const SELECTION_FG_VAR = '--hw-dark-selection-fg'

const selectionToken = (colorScheme: ColorScheme, part: 'bg' | 'fg') =>
  tokenVar(
    `colors.${tokenPrefix(colorScheme)}interactive.text-selection-${part}`
  )

// Both selector forms: '& ::selection' covers descendants, '&::selection'
// covers text nodes rendered directly under the scope element.
export const selectionCss = (colorScheme?: ColorScheme) => ({
  '&::selection, & ::selection': colorScheme
    ? {
        backgroundColor: selectionToken(colorScheme, 'bg'),
        color: selectionToken(colorScheme, 'fg'),
      }
    : {
        backgroundColor: `var(${SELECTION_BG_VAR}, ${selectionToken(
          'dark',
          'bg'
        )})`,
        color: `var(${SELECTION_FG_VAR}, ${selectionToken('dark', 'fg')})`,
      },
})
